<template>
  <div>
    <popup :message="alertErrMessage" v-if="isAlertErr" :isError="isError" @close="isAlertErr = false" />

    <div class="hero">
      <div class="content">
        <h1>{{ $t('corporateCollab.heroSection.title') }}</h1>
        <p>{{ $t('corporateCollab.heroSection.description') }}</p>
        <div class="btn-cta">
          <button class="now" @click="scrollToSection('collab')">{{
            $t('corporateCollab.heroSection.ctaButtons.collaborateNow') }}</button>
          <button class="call" @click="sendToWa"> {{ $t('corporateCollab.heroSection.ctaButtons.contactUs') }}</button>
        </div>
      </div>
      <div class="card-img">
        <img src="/img/corporate/collaboration/collaboration.png" width="520" height="" alt="" />
      </div>
    </div>
    <div class="container-fade">
      <div class="left-fade"></div>
      <div class="right-fade"></div>
    </div>
    <div class="logo">
      <h1>{{ $t('corporateCollab.trustedPartners.title') }}</h1>
      <div class="card" style="overflow-x: none !important">
        <div v-for="(partner, index) in partners" :key="index">
          <div class="logo-card-partner-2">
            <img :src="partner.img_url_web" width="160" />
          </div>
        </div>
      </div>
    </div>

    <div class="product-collaboration">
      <h1>{{ $t('corporateCollab.heroSection.a1') }}</h1>
      <p>
        {{ $t('corporateCollab.heroSection.a2') }}
      </p>
      <div class="card-product">
        <div class="product" v-for="(item, index) in $t(`corporateCollab.products`)" :key="index">
          <img :src="item.icon" width="60" height="60" alt="" />
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>

    <div class="bg-linear">
      <div class="usp">
        <div class="card-usp">
          <h1>{{ $t('corporateCollab.uspSection.title') }}</h1>
          <p v-html="$t('corporateCollab.uspSection.subtitle')"></p>
          <div class="card-img">
            <img src="/img/corporate/collaboration/training.png" alt="" />
          </div>
        </div>
        <div class="usp-container">
          <div class="card-usp" v-for="(usp, index) in usps" :key="index">
            <div class="title-container mb-2">
              <img :src="usp.image" width="45" height="45" alt="" />
              <div>
                <h3>{{ $t(`corporateCollab.uspSection.items.${index}.title`) }}</h3>
                <p>{{ $t(`corporateCollab.uspSection.items.${index}.desc`) }}</p>
              </div>
            </div>
            <div class="content">
            </div>
            <hr />
          </div>
        </div>
      </div>

      <StepCollaboration :title="$t(`corporateCollab.stepsSection.title`)"
        :steps="$t('corporateCollab.stepsSection.steps')" />
    </div>

    <portofolio :title="$t('corporateCollab.heroSection.a3')" :portfolios="portfolios" />
    <Testimony :title="$t('corporateCollab.heroSection.a4')" :testimonies="testimonies" />

    <div class="form-konsultasi" id="collab">
      <div class="header text-center">
        <h1>{{ $t('corporateCollab.formSection.title') }}</h1>
      </div>

      <div class="sub-heading mt-1 text-center">
        <p>{{ $t('corporateCollab.formSection.subTitle') }}</p>
      </div>

      <v-form class="text-start" style="margin-top: 60px">
        <v-row>
          <v-col cols="6">
            <label class="form-label" for="company">
              {{ $t('corporateCollab.formSection.labels.companyName') }}
              <span style="color: rgba(184, 15, 10, 1)">*</span>
            </label>
            <v-text-field class="form-input text-form" name="company" v-model="form.corporate_name" outlined
              :placeholder="$t('corporateCollab.formSection.placeholders.companyName')"></v-text-field>
          </v-col>
          <v-col cols="6">
            <label class="form-label" for="website">
              {{ $t('corporateCollab.formSection.labels.website') }}
            </label>
            <v-text-field class="form-input text-form" name="website" v-model="form.web_url" outlined
              :placeholder="$t('corporateCollab.formSection.placeholders.website')"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <label class="form-label" for="pic-name">
              {{ $t('corporateCollab.formSection.labels.picName') }}
              <span style="color: rgba(184, 15, 10, 1)">*</span>
            </label>
            <v-text-field class="form-input text-form" name="pic-name" v-model="form.full_name" outlined
              :placeholder="$t('corporateCollab.formSection.placeholders.picName')"></v-text-field>
          </v-col>
          <v-col cols="6">
            <label class="form-label" for="occupation">
              {{ $t('corporateCollab.formSection.labels.occupation') }}
            </label>
            <v-text-field class="form-input text-form" name="occupation" v-model="form.job_pic" outlined
              :placeholder="$t('corporateCollab.formSection.placeholders.occupation')"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <label class="form-label" for="email">
              {{ $t('corporateCollab.formSection.labels.email') }}
              <span style="color: rgba(184, 15, 10, 1)">*</span>
            </label>
            <v-text-field class="form-input text-form" name="email" v-model="form.email" outlined
              :placeholder="$t('corporateCollab.formSection.placeholders.email')"></v-text-field>
          </v-col>
          <v-col cols="6">
            <label class="form-label" for="phone-number">
              {{ $t('corporateCollab.formSection.labels.phoneNumber') }}
              <span style="color: rgba(184, 15, 10, 1)">*</span>
            </label>
            <v-text-field class="form-input text-form" name="phone-number" outlined
              :placeholder="$t('corporateCollab.formSection.placeholders.phoneNumber')" type="number"
              v-model="form.phone_number" hide-spin-buttons>
              <template v-slot:prepend-inner>
                <v-row class="d-flex align-center mt-0 ml-7">
                  <img src="/img/other/flag-indonesia.png" alt="" width="30" height="20"
                    style="box-shadow: 2px 2px 3px 1px rgba(13, 28, 113, 0.1)" />
                  <span style="color: #575966" class="mx-3">+62</span>
                </v-row>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="form-collab">
            <label class="form-label" for="collaboration">
              {{ $t('corporateCollab.formSection.labels.collaborationType') }}
            </label>
            <v-text-field class="form-input text-form" solo flat background-color="rgba(247, 249, 253, 1)"
              placeholder="Corporate Collaboration" disabled></v-text-field>
          </v-col>
        </v-row>

        <v-row class="d-flex justify-center align-center mt-3">
          <v-checkbox class="form-input custom-checkbox" v-model="is_confirm">
            <template v-slot:label>
              <p class="label-checkbox">{{ $t('corporateCollab.formSection.labels.confirmCheckbox') }}</p>
            </template>
          </v-checkbox>
        </v-row>

        <v-row class="d-flex justify-center align-center mt-6">
          <v-btn elevation="0" :class="`btn-kirim ${is_confirm ? 'confirm' : 'reject'}`" @click="onSubmit">
            {{ $t('corporateCollab.formSection.buttons.submit') }}
          </v-btn>
        </v-row>
      </v-form>
    </div>
    <div class="faq" style="margin-top: 60px;">
      <div class="content">
        <div class="row">
          <div class="col-lg-3">
            <div class="header" style="margin-bottom: 20px;">
              <h1>Frequently Asked Question</h1>
            </div>
          </div>
          <div class="col-lg-9" style="margin-top: -10px;">
            <v-expansion-panels flat class="faq-card" style="padding: 20px; background-color: #F1F6FF;">
              <v-expansion-panel v-for="(item, index) in questions" :key="index"
                style="border-radius: 20px; padding: 0; margin-bottom: 10px;">
                <v-expansion-panel-header disable-icon-rotate @click="openFaq(index, item.title)">
                  <h2 style="margin: 25px 0; font-size: 18px;">{{ item.title }}</h2>
                  <template v-slot:actions>
                    <div class="icon" v-if="item.active">
                      <Arrow />
                    </div>
                    <div v-else>
                      <Arrow :down="!item.active" />
                    </div>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-html="item.description"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div class="btn-stoke-blue" @click="goToFaq">
              <span class="font-poppins">{{ $t('corpAceleration.faqSection.viewMore') }}</span>
              <ArrowLong />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Portofolio from '../../Portofolio.vue';
import StepCollaboration from '../../StepCollaboration.vue';
import Testimony from "../../Testimony.vue";
import Popup from "@/components/others/Popup.vue";
import Arrow from '@/assets/icons/Arrow.vue';
import ArrowLong from '@/assets/icons/ArrowLong.vue';

export default {
  components: {
    StepCollaboration,
    Testimony,
    Portofolio,
    Popup,
    Arrow,
    ArrowLong
  },
  name: "DesktopCorporateCollaboration",
  data() {
    return {
      partners: [],
      usps: [
        {
          image: "/img/corporate/collaboration/b1.png",
          title: "Kolaborasi Inklusif",
          desc: "Layanan kolaborasi yang dirancang untuk membangun budaya kerja inklusif dan membangun Tim yang lebih kuat dan kolaboratif",
        },
        {
          image: "/img/corporate/collaboration/b2.png",
          title: "Bangun Kredibilitas Mitra",
          desc: "HiColleagues dapat memberikan validitas tambahan pada perusahaan Anda sebagai our trusted partner.",
        },
        {
          image: "/img/corporate/collaboration/b3.png",
          title: "Tingkatkan Produktivitas & Efisiensi Tim",
          desc: "Bermitra dengan HiColleagues untuk membuka potensi penuh tim Anda dan mencapai tujuan bisnis secara lebih efektif.",
        },
        {
          image: "/img/corporate/collaboration/b4.png",
          title: "Strategi Kolaboratif Terbaik",
          desc: "Layanan kolaborasi yang menerapkan strategi kolaboratif dan solusi terpadu dalam membantu untuk mencapai tujuan bisnis Anda.",
        },
        {
          image: "/img/corporate/collaboration/b5.png",
          title: "Best Practice",
          desc: "Penerapan best practice & metodologi kolaboratif yang telah terbukti efektif di berbagai industri. HiColleagues memiliki proses kontrol kualitas yang ketat untuk memastikan program kolaborasi memenuhi standar tertinggi.",
        },
        {
          image: "/img/corporate/collaboration/b6.png",
          title: "Tingkat kepuasan Klien yang Tinggi",
          desc: "HiColleagues berkomitmen untuk terus memberikan tingkat kepuasan klien yang unggul dengan layanan kolaborasi terbaik.",
        },
      ],
      portfolios: [],
      questions: [],
      testimonies: [],
      alertErrMessage: "",
      isAlertErr: false,
      is_confirm: false,
      isError: false,
      form: {
        full_name: "",
        email: "",
        phone_number: "",
        gender: "",
        corporate_name: "",
        company_field: "",
        program: "",
        total_student: 0,
        notes: "",
        category: "COLLABORATION",
        web_url: "",
        job_pic: ""
      },
    };
  },
  watch: {
    "$i18n.locale"() {
      this.getTestimoni();
      this.getPortofolio();
      this.getFaq();
    },
  },
  methods: {
    duptlicatePartners() {
      this.partners = this.partners.concat(this.partners, this.partners, this.partners);
    },
    async getClientLogo() {
      try {
        const resp = await this.$http.get('/v1/logo?category=COLLABORATION');
        this.partners = resp.data.data.logos;
        this.duptlicatePartners();
      } catch (err) {
        console.log(err);
      }
    },
    async getTestimoni() {
      try {
        const resp = await this.$http.get(`/v1/testimony?category=COLLABORATION&page=1&per_page=9`);
        this.testimonies = resp.data.data.testimonies;
      } catch (err) {
        console.log(err);
      }
    },
    async getPortofolio() {
      try {
        const resp = await this.$http.get(`/v1/project-portfolio?category=COLLABORATION&is_main=true`);
        this.portfolios = resp.data.data.project_portfolios;
      } catch (err) {
        console.log(err);
      }
    },
    openFaq(idx, title) {
      this.$gtag.event('click', {
        event_category: 'FAQ',
        event_label: `Open FAQ - ${title}`,
        value: 1,
      });
      const valDef = this.questions[idx].active;
      this.questions.forEach(e => {
        e.active = false;
      });
      this.questions[idx].active = !valDef;
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(`/v1/faq?category=COLLABORATION&is_main=true`);
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false
        }));
      } catch (err) {
        console.log(err);
      }
    },
    sendToWa() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Contact Us - WhatsApp',
        value: 1,
      });
      window.open(
        "https://api.whatsapp.com/send/?phone=6285110563798&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya",
        "_blank"
      );
    },
    scrollToSection(sectionId) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Collaborate Now - Scroll to Form',
        value: 1,
      });
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    async onSubmit() {
      this.$gtag.event('click', {
        event_category: 'Form',
        event_label: 'Submit Collaboration Form',
        value: 1,
      });
      if (!this.is_confirm) {
        return;
      }
      if (!this.form.corporate_name || !this.form.full_name || !this.form.job_pic || !this.form.email || !this.form.phone_number || !this.form.category || !this.form.web_url) {
        this.alertErrMessage = "Harap isi semua form yang tersedia";
        this.isAlertErr = true;
        this.isError = true;
        return;
      }
      try {
        await this.$http.post('/v1/corporate-registration', this.form);
        this.alertErrMessage = "Success";
        this.isAlertErr = true;
        this.isError = false;
        this.clearForm();
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Collaboration Form Submission Success',
          value: 1,
        });
      } catch {
        this.alertErrMessage = "Error saat submit data";
        this.isAlertErr = true;
        this.isError = true;
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Collaboration Form Submission Error',
          value: 0,
        });
      }
    },
    goToFaq() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'View More FAQs',
        value: 1,
      });
      this.$router.push('/faq');
    },
    clearForm() {
      this.is_confirm = false;
      this.form.full_name = "";
      this.form.email = "";
      this.form.phone_number = "";
      this.form.corporate_name = "";
      this.form.category = "";
      this.form.web_url = "";
      this.form.job_pic = "";
    },
  },
  mounted() {
    this.getClientLogo();
    this.getTestimoni();
    this.getPortofolio();
    this.getFaq();
  },
};
</script>

<style src="./corporateCollaboration.css" scoped></style>